import { useCallback } from "react";
import { CommandStatus, useCommand } from "@lookiero/messaging-react";
import { Logger } from "@lookiero/sty-psp-logging";
import { reconciliateCheckoutBooking } from "../../../../domain/checkoutBooking/command/reconciliateCheckoutBooking";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface ReconciliateFunction {
  (): Promise<void>;
}

type UseReconciliateCheckoutBooking = [reconciliate: ReconciliateFunction, status: CommandStatus];

interface UseReconciliateCheckoutBookingFunctionArgs {
  readonly checkoutBookingId: string | undefined;
  readonly checkoutId: string | undefined;
  readonly logger: Logger;
}

interface UseReconciliateCheckoutBookingFunction {
  (args: UseReconciliateCheckoutBookingFunctionArgs): UseReconciliateCheckoutBooking;
}

const useReconciliateCheckoutBooking: UseReconciliateCheckoutBookingFunction = ({
  checkoutBookingId,
  checkoutId,
  logger,
}) => {
  const [commandBus, status] = useCommand({ contextId: MESSAGING_CONTEXT_ID });

  const reconciliate = useCallback(async () => {
    if (!checkoutBookingId || !checkoutId) return;

    try {
      await commandBus(reconciliateCheckoutBooking({ aggregateId: checkoutBookingId, checkoutId }));
    } catch (error) {
      logger.captureException(error as Error);
    }
  }, [checkoutBookingId, checkoutId, commandBus, logger]);

  return [reconciliate, status];
};

export { useReconciliateCheckoutBooking };
